import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Anchor, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

const DEV_EMAIL = "scott.scarboro@gmail.com";
const DEV_PASSWORD = "MtmMarine2026!";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const doLogin = async (em, pw) => {
    setBusy(true);
    try {
      await login(em, pw);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-mtm-charcoal flex items-center justify-center p-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="flex items-center justify-center gap-2.5 mb-8">
          <span className="h-11 w-11 rounded-lg bg-gradient-to-br from-mtm-violet to-mtm-teal flex items-center justify-center text-white"><Anchor size={24} /></span>
          <div className="flex flex-col leading-none">
            <span className="font-heading font-extrabold text-xl text-white">MTM Marine</span>
            <span className="text-[10px] font-mono uppercase tracking-widest text-mtm-teal-bright">Admin Console</span>
          </div>
        </div>
        <div className="bg-white rounded-2xl p-8 shadow-2xl">
          <h1 className="font-heading font-bold text-2xl text-slate-900">Sign In</h1>
          <p className="text-sm text-slate-500 mt-1">Access the MTM dealership admin.</p>
          <form onSubmit={(e) => { e.preventDefault(); doLogin(email, password); }} className="space-y-4 mt-6">
            <div><Label htmlFor="email">Email</Label><Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" /></div>
            <div><Label htmlFor="password">Password</Label><Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" /></div>
            <Button type="submit" disabled={busy} className="w-full bg-mtm-purple hover:bg-mtm-purple-deep text-white rounded-full" data-testid="login-submit-button">{busy ? "Signing in..." : "Sign In"}</Button>
          </form>
          <div className="relative my-5"><div className="border-t border-slate-200" /><span className="absolute left-1/2 -translate-x-1/2 -top-2.5 bg-white px-3 text-xs text-slate-400">Development</span></div>
          <Button variant="outline" disabled={busy} onClick={() => doLogin(DEV_EMAIL, DEV_PASSWORD)} className="w-full border-mtm-teal text-mtm-teal-dark hover:bg-mtm-teal hover:text-white rounded-full" data-testid="admin-quick-login-button">
            <Zap size={16} /> Login as Admin (Dev)
          </Button>
          <p className="text-[11px] text-slate-400 text-center mt-3">Quick-access button for testing, remove before launch.</p>
        </div>
      </div>
    </div>
  );
}
